<template>
    <div>
        <Title title="免责声明" :path="formPath"/>

        <div class="abbox">
            <div class="abnav">
                <router-link to="/about">关于我们</router-link>
                <router-link to="/mianze" class="curr">免责声明</router-link>
                <router-link to="/treaty">用户协议</router-link>
                <router-link to="/contact">联系我们</router-link>
            </div>
            <div class="abright">
                <div class="abmain">
                    <div class="con abmianze">
                        <Mianze_mini/>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Title from '../public/title'
    import Mianze_mini from '../public/mianze_mini'
    export default {
        name: "mianze",
        components: {
          Title,
            Mianze_mini
        },
        data() {
            return {
                formPath: ''
            }
        },
        activated() {
            this.$backTop()
        },
        methods: {
        },
        beforeRouteEnter(to, form, next){
            next(vm => {
                vm.formPath = form.path === '/' ?'/my':''
            })
        }
    }
</script>

<style scoped>
</style>
